export default "__VITE_ASSET__bc0cac54__"